'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getComponentDisplayName;
/**
 * @copyright 2015-present Prometheus Research, LLC
 * 
 */

function getComponentDisplayName(Component) {
  return typeof Component === 'string' ? Component : Component.displayName || Component.name || 'Component';
}
